import React, { Component } from "react";
import { Link } from "react-router-dom";


export class Footer extends Component {
  render() {
    return (
      <div
        className="row"
        style={{
          position: "relative",
          width: "100%",
          color: "white",
          display: "inline-block",
          padding: "2% 0% 0% 0%",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999
        }}
      >
        <div>
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "white",
              fontWeight: "700",
              fontSize: "18px",
              padding: "0% 2% 0% 0%"
            }}
          >
            App
          </Link>
          {/* <Link
            to="/corporate"
            style={{
              textDecoration: "none",
              color: "white",
              padding: "0% 2% 0% 0%"
            }}
          >
            Corporate
          </Link> */}
          <Link
            to="/team"
            style={{
              textDecoration: "none",
              color: "white",
              fontWeight: "700",
              fontSize: "18px",
              padding: "0% 2% 0% 0%"
            }}
          >
            Team
          </Link>
          <Link
            to="/contact"
            style={{
              textDecoration: "none",
              color: "white",
              fontWeight: "700",
              fontSize: "18px",
              padding: "0% 2% 0% 0%"
            }}
          >
            Contact
          </Link>

          <p style={{ padding: "0% 2% 0% 0%" }}> © 2020 Kinder World, PBC</p>
        </div>
      </div>
    );
  }
}

